import { z } from 'zod';
/** Server-side pagination envelope shared by every list endpoint. */
export const PageQuerySchema = z.object({
    page: z.coerce.number().int().min(1).max(100000).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export const SortDirectionSchema = z.enum(['asc', 'desc']);
export const PageMetaSchema = z.object({
    page: z.number().int(),
    pageSize: z.number().int(),
    totalItems: z.number().int(),
    totalPages: z.number().int(),
    generatedAt: z.iso.datetime(),
});
export function pageMeta(page, pageSize, totalItems) {
    return {
        page,
        pageSize,
        totalItems,
        totalPages: Math.max(1, Math.ceil(totalItems / pageSize)),
        generatedAt: new Date().toISOString(),
    };
}
//# sourceMappingURL=pagination.js.map